/** @file setPoseCommand: one `clip.setPose` that writes some nodes and keeps the frame's other keyed nodes. */
import type { Command } from '@zilo/pose3d-commands/types/command';
import type { Clip, NodeKey } from '@zilo/pose3d-format/types/clip';

/**
 * `clip.setPose` replaces the whole key at `frame`, so the nodes already keyed there are sent along with `nodes`
 * (which win); one command per gesture keeps undo at one step.
 */
export function setPoseCommand(clip: Pick<Clip, 'name' | 'keys'>, frame: number, nodes: Record<string, NodeKey>): Command {
  const kept = clip.keys.find((k) => k.frame === frame)?.nodes ?? {};
  return { name: 'clip.setPose', input: { clip: clip.name, frame, nodes: { ...structuredClone(kept), ...nodes } } };
}
